export class Message {
  public id: string;
  public title: string;
  public content: string;
  public date: Date;
  public application: string;
  public icon: string;
  public type: string;
  public settings: any;
  public isRead: boolean;

  constructor(id: string, title: string, content: string) {
    this.id = id;
    this.title = title;
    this.content = content;
  }
}
